import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createGame } from './actions';
import { getUsers } from '../Users/actions';
import { selectUsers, selectUsersLoaded } from '../Users/selectors';
import { selectCreating } from './selectors';
import { Button, Muted, Select } from '../Controls';

const CreateGame = () => {
  const dispatch = useDispatch();
  const users = useSelector(selectUsers);
  const usersLoaded = useSelector(selectUsersLoaded);
  const creating = useSelector(selectCreating);

  const [opponentId, changeOpponentId] = useState('');

  useEffect(() => {
    if (users.size) {
      changeOpponentId(users.first().get('id'));
    }
  }, [users]);

  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);

  if (!usersLoaded) {
    return <Muted>Loading players…</Muted>;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(createGame(opponentId));
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      <Select aria-label="Opponent" onChange={(e) => changeOpponentId(e.target.value)} value={opponentId}>
        {users.map((user) => (
          <option key={user.get('id')} value={user.get('id')}>{user.get('name')}</option>
        ))}
      </Select>
      <Button $primary disabled={creating}>{creating ? 'Starting…' : 'Start game'}</Button>
    </form>
  );
};

export default CreateGame;
